import { render, staticRenderFns } from "./ShimmerCardGrid.vue?vue&type=template&id=0247e868&scoped=true&"
import script from "./ShimmerCardGrid.vue?vue&type=script&lang=js&"
export * from "./ShimmerCardGrid.vue?vue&type=script&lang=js&"
import style0 from "./ShimmerCardGrid.vue?vue&type=style&index=0&id=0247e868&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0247e868",
  null
  
)

export default component.exports